import { render, staticRenderFns } from "./DeliveryZoneSchedules.vue?vue&type=template&id=179f731e&scoped=true"
import script from "./DeliveryZoneSchedules.vue?vue&type=script&lang=js"
export * from "./DeliveryZoneSchedules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179f731e",
  null
  
)

export default component.exports